<template>
    <div class="text-sm">
        <span> Trvalý odkaz: </span>

        <span class="italic">
            {{ composedUrl }}
        </span>

        <a class="link ml-1" href="#" @click.prevent="editSlug()"> Zmeniť </a>

        <ClientOnly>
            <EditSlugModal
                ref="editSlugModalRef"
                v-model="showModal"
                :collection="collection"
                :exclude-id="excludeId"
                :path="path"
                :slug="modelValue"
                @close="handleClose"
            />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import EditSlugModal from '@/components/modals/EditSlugModal.vue'
import { useSlug } from '@/composables/slug/useSlug'

interface Props {
    collection: string
    path?: string
    modelValue?: string
    excludeId?: string
    attribute?: string
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    path: '',
    modelValue: '',
    excludeId: '',
    attribute: '',
    disabled: false
})

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

const showModal = ref(false)
const editSlugModalRef = ref()
const isResolvingSlug = ref(false)
const requestURL = useRequestURL()
const { resolveSlug } = useSlug()

const composedUrl = computed((): string => {
    const origin = import.meta.client ? window.location.origin : requestURL.origin
    const val = props.path ? [origin, props.path, props.modelValue] : [origin, props.modelValue]
    return val.filter(Boolean).join('/')
})

function editSlug() {
    if (props.disabled) return
    showModal.value = true
}

function handleClose(value?: string) {
    if (value) {
        emit('update:modelValue', value)
    }
    showModal.value = false
}

async function suggestSlug(name: string) {
    isResolvingSlug.value = true
    const value = await resolveSlug(props.collection, name, props.excludeId, props.attribute)
    emit('update:modelValue', value)
    isResolvingSlug.value = false
}

defineExpose({
    suggestSlug
})
</script>
